module.exports = "<a routerLink=\"{{ contentTitre.url }}\">{{ contentTitre.nom }}</a>\n"